import React from "react";

import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from "@/components/ui/tooltip";
import { Grund } from "@/hilfe/Grund";
import { eintrag, istSeite } from "@/hilfe/register";

// Hilfe am Knopf (Auftrag 8, R3) -- von <Button grund hilfe> benutzt.

/**
 * Der Grund einer Sperre, wenn mehrere Bedingungen einen Knopf ausgrauen:
 * die erste zutreffende zählt. Jedes Paar ist [Bedingung, Text] -- der Text
 * sagt in Worten, was die Bedingung im Code prüft, nicht, warum es sie gibt.
 *
 *   disabled={saving || !gewaehlt}
 *   grund={sperre([saving, "Wird gespeichert"], [!gewaehlt, "Keine Zuordnung gewählt"])}
 */
export const sperre = (...paare) => {
    const p = paare.find(([bedingung]) => bedingung);
    return p ? p[1] : undefined;
};

// Was die Hülle vom Knopf übernehmen muss, damit er an seinem Platz bleibt:
// Breite und Lage in der umgebenden Zeile.
const LAGE = /^(w-|min-w-|max-w-|flex-1|flex-none|grow|shrink|ml-|mr-|mt-|mb-|mx-|my-|m-|self-|order-|col-span-)/;

export const SperrGrund = ({ grund, className = "", testId, children }) => {
    const lage = String(className || "").split(/\s+/).filter((k) => LAGE.test(k));
    const breit = lage.some((k) => k === "w-full");
    return (
        <Grund text={grund} testId={testId ? `${testId}-grund` : undefined}
               className={`${breit ? "flex" : "inline-flex"} ${lage.join(" ")}`}>
            {children}
        </Grund>
    );
};

export const Wirkung = ({ id, children }) => {
    if (istSeite(id)) throw new Error(`<Button hilfe="${id}">: Seitenköpfe gehören in <Seitenkopf>`);
    const e = eintrag(id);
    if (!e) return children;
    // Nur Tooltip: Ein Tippen auf einen aktiven Knopf löst ihn aus -- ein
    // Popover dazwischen würde jede Aktion um einen Schritt verlängern.
    return (
        <TooltipProvider delayDuration={300}>
            <Tooltip>
                <TooltipTrigger asChild>{children}</TooltipTrigger>
                <TooltipContent className="max-w-xs font-normal">{e.text}</TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
};
